import axios from 'axios'
let appData = []
const channelId = '1913226797825179650'
export async function getAppdata() {
  if (appData.length > 0) {
    return appData
  } else {
    let path = `/dom/apps/app/${channelId}`
    await axios.get(path).then((response) => {
      let result = JSON.parse(encode64(response.data))
      // 筛选有模版id的应用
      result.map((item) => {
        if (item.resourceTemplateId) {
          appData.push({ ...item })
        }
      })
      console.log(appData, 'result')
    })
    return appData
  }
}
export function requestAppData() {
  let path = `/dom/apps/app/${channelId}`
  return axios.get(path).then((response) => {
    let result = JSON.parse(encode64(response.data))
    // 筛选有模版id的应用
    result.map((item) => {
      if (item.resourceTemplateId) {
        appData.push({ ...item })
      }
    })
    console.log(appData, 'result')
  })
}
export function requestAdData() {
  let path = `/dom/apps/ad/${channelId}`
  return axios.get(path).then((response) => {
    let result = JSON.parse(encode64(response.data))
    console.log(appData, 'resultad')
    // 筛选有模版id的应用
    return result
    
  })
}
export function requestAppResource(appId) {
  let path = `/dom/apps/app-resource/${channelId}_${appId}`
  return axios.get(path).then((response) => {
    let result = JSON.parse(encode64(response.data))
    // 筛选有模版id的应用
    return result
  })
}
export function requestTempalteConfig(id) {
  let path = `/dom/apps/template-param/${id}`
  return axios.get(path).then((response) => {
    let result = JSON.parse(encode64(response.data))
    // 筛选有模版id的应用
    return result
  })
}
export function requestImageConfig() {
  let path = `/dom/apps/image-config/config`
  return axios.get(path).then((response) => {
    let result = JSON.parse(encode64(response.data))
    // 筛选有模版id的应用
    return result
  })
}

function encode64(str) {
  return decodeURIComponent(
    atob(str)
      .split('')
      .map((c) => '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2))
      .join('')
  )
}
